export default "__VITE_ASSET__CZLQ3uRa__"